import React, {useEffect, useState} from "react";
import general from "../../../general";
import {Link} from "react-router-dom";
import $ from "jquery";
import {useScroll, useLockFn, useMount} from "ahooks";
import Dialog from "../../../lib/Dialog";
import Image from "../../../lib/Image";
import useActiveState from '../../../lib/useActiveState';
import Subtitle from "../../components/Subtitle";
import FreeEdition from "../../components/FreeEdition";
import GameTags from "../../components/game/GameTags";

// export default ({active, type}) => {
export default props => {
  const [page, setPage] = useState(1);
  const [games, setGames] = useState([]);
  const [more, setMore] = useState(true);
  const [obsolete, setObsolete] = useState();
  const [user] = useActiveState('user');
  const [agent] = useActiveState('agent');
  const [randomColorInfo] = useActiveState('randomColorInfo');
  const [init, setInit] = useState(false);

  const load = useLockFn(async (parms = {}) => {
    Dialog.loading();
    let tmp = {
      type: 4,
      // game_species_type: type,
      game_species_type: 1,
      pagination: {count: 20, page: page},
    };
    if (parms.page) {
      tmp.pagination.page = parms.page;
    }
    await general.axios.post('/base/game/getGameList', tmp)
      .finally(() => {
        Dialog.close();
      })
      .then(res => {
        let {status, data} = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
          return;
        }
        setInit(true);
        setObsolete(false);
        parms.page && setPage(parms.page);
        let {game_list: list, paginated} = data;
        list.forEach(d => {
          d.infoColor = randomColorInfo[parseInt(Math.random() * 4)]
        })
        setGames(games => parms.page === 1 || !parms.page ? list : [...games, ...list]);
        setMore(paginated.more && list.length > 0);
      })
      .catch(err => {
        Dialog.error(err.message);
      });
  });

  // useMount(() => load());
  // useEffect(() => {
  //   if (active) {
  //     load({page: 1});
  //   } else {
  //     setObsolete(true);
  //   }
  // }, [type]);
  // useEffect(() => {
  //   if (active && obsolete) {
  //     load({page: 1});
  //   }
  // }, [active, obsolete]);

  useEffect(() => {
    if (props.active && !init) {
      load();
    }
  }, [props.active]);

  const scroll = useScroll();
  useEffect(() => {
    if (props.active && init) {
      if (scroll.top < -80) {
        load({page: 1});
      }
      if (scroll.top + window.innerHeight + 20 > $(document).height() && more) {
        load({page: page + 1});
      }
    }
  }, [scroll, props.active]);

  const clickGameOfTheRankList = (game) => {
    
  }

  return <div className="game-new">
    {games.map((game, index) => <Link to={'/game?id=' + game.game_id} className="game-new-item" onClick={()=>clickGameOfTheRankList(game)}>
      {index < 3 ? <div className="index">
          <img src={'/resources/index/new-' + (index < 3 ? index + 1 : 'more') + '.png'}/>
          {index > 2 ? <div>{index + 1}</div> : null}
          </div>:null}
      <div className="icon">
        <Image src={game.game_image.thumb}/>
        {/* {game.discount < 1 ? <div className="discount">{game.discount * 10}折</div> : null} */}
        {
          game?.lablePosition == 2 && game.top_lable != '' ?
          <div className="iconlable jx" style={{backgroundImage: 'linear-gradient('+game?.lableColor.t+', '+game?.lableColor.b+')'}}>
            {game.top_lable}
          </div>
          : null
        }
      </div>
      <div className="subject">
        <div className="text">
          <div className="name">
            {/* {game.top_lable != '' ? <span>{game.top_lable }</span> : null }{game.game_name} */}
            <div className={" " + (game.nameRemark ? " name-new" : "")}>
              {game?.lablePosition == 1 && game.top_lable != '' ? <span className="span">{game.top_lable }</span> : null }
              {game.game_name}
            </div>
          </div>
          <div className="info1">
            {game.game_classify_type.trim()}
            <Subtitle>{game.nameRemark}</Subtitle>
          </div>
          <GameTags game={game}></GameTags>
        </div>
        {/* {game.discount < 1 ? <div className="discount" ><span>{game.discount * 10}</span>折</div> : null} */}
      </div>
      <FreeEdition>{game}</FreeEdition>
    </Link>)}
    {games.length > 6 && !more ? <div className="view-end">别撩啦！已经到底啦~</div> : null}
  </div>;
};